import { useCallback, useEffect, useState } from 'react';

import { useLanguage } from '../../contexts/language';
import { useRequest } from '../../hooks/request';

import styles from './style.module.css';

// Asking for another code, after the same 30 seconds the auth service waits
// before it sends one. Counting down here means the button is offered only
// when the service will accept it, rather than inviting a refusal.
export function ResendCode({ email }) {
  const { text, translate } = useLanguage();
  const request = useRequest();
  const [ seconds, setSeconds ] = useState(30);
  const [ notice, setNotice ] = useState();

  useEffect(function() {
    if (seconds === 0) {
      return undefined;
    }

    const timer = setTimeout(function() {
      setSeconds(seconds - 1);
    }, 1000);

    return function() {
      clearTimeout(timer);
    };
  }, [ seconds ]);

  const onClick = useCallback(function() {
    setSeconds(30);

    return request({ path: '/auth/code', method: 'POST', body: { email } }).then(function() {
      setNotice(text.codeResent);
    }).catch(function(failed) {
      setNotice(translate(failed.message));
    });
  }, [ email, request, text, translate ]);

  let control = <span className={ styles.wait }>{ `${ text.resendIn } 0:${ String(seconds).padStart(2, '0') }` }</span>;

  if (seconds === 0) {
    control = <button className={ styles.button } type='button' onClick={ onClick }>{ text.resend }</button>;
  }

  let status = null;

  if (typeof notice === 'string') {
    status = <span className={ styles.notice } role='status'>{ notice }</span>;
  }

  return (
    <div className={ styles.resend }>
      { control }

      { status }
    </div>
  );
}
